import scrollbarWidth from 'scrollbar-width';

export type NodeList = NodeListOf<HTMLElement>;

export const stickySupported = () => {
  const el = document.createElement('a');
  const mStyle = el.style;
  mStyle.cssText =
    'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
  return mStyle.position.includes('sticky');
};

export interface SyncedElements {
  tableWrapperEl: HTMLDivElement /* div wrapping the real table */;
  proxyTableWrapperEl: HTMLDivElement /* fixed position div wrapping the proxy header */;
}

export const syncProxyHeader = ({
  tableWrapperEl,
  proxyTableWrapperEl,
}: SyncedElements): void => {
  if (!tableWrapperEl || !proxyTableWrapperEl) {
    return;
  }

  const tableEl = tableWrapperEl.querySelector('table');
  const proxyTableEl = proxyTableWrapperEl.querySelector('table');

  // Get the size and position of the real table relative to the viewport
  proxyTableWrapperEl.style.width = tableEl.offsetWidth + 'px';
  const { top, left } = tableWrapperEl.getBoundingClientRect();

  // Set the proxy table position on top of the actual header
  proxyTableWrapperEl.style.top = top + 'px';
  proxyTableWrapperEl.style.left = left + 'px';

  const proxyTableExpectedWidth = tableWrapperEl.offsetWidth - scrollbarWidth();
  proxyTableWrapperEl.style.width = `${proxyTableExpectedWidth}px`;

  // Set the proxy header cells to be the same width as real header cells
  const cellSelector = 'thead td';
  const realHeaderCells: NodeList = tableWrapperEl.querySelectorAll(cellSelector);
  const proxyHeaderCells: NodeList = proxyTableWrapperEl.querySelectorAll(cellSelector);

  for (let i = 0; i < proxyHeaderCells.length; i++) {
    const proxyCell = proxyHeaderCells[i];
    const realCell = realHeaderCells[i];
    proxyCell.style.width = `${realCell.offsetWidth}px !important`;
  }

  // Sync the proxy table with the horizontal scroll of the real table
  proxyTableEl.style.left = -1 * tableWrapperEl.scrollLeft + 'px';
};
